import { GiphyFetch } from '@giphy/js-fetch-api';
import { IGif } from '@giphy/js-types';
import { Carousel } from '@giphy/react-components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button } from '../../../_atoms/Button';

const giphyFetch = new GiphyFetch('fG3fCsjdKR7IQXZIkjSSQwqxu6tq8Jns'); // TODO: add this as env variable

const GiphyRow = ({
  onGifSelected,
  onClickSeeMore,
}: {
  onClickSeeMore: () => void;
  onGifSelected: (gifId: string, width: number, height: number) => void;
}) => {
  const { t } = useTranslation('Host');

  const fetchTrendyGifs = (offset: number) => {
    return giphyFetch.trending({ offset, limit: 20 });
  };

  const handleGIFClicked = (gif: IGif) => {
    const { width, height } = gif.images.original;

    onGifSelected(`${gif.id}`, width, height);
  };

  return (
    <RowContainer>
      <TitleContainer>
        <span style={{ padding: '1%' }}>Giphy</span>
        <Button
          onClick={() => {
            onClickSeeMore();
          }}
          styles={{ fontSize: 12 }}
          type="ghost"
        >
          {t('Browse all')}
        </Button>
      </TitleContainer>
      <Carousel
        backgroundColor={undefined}
        fetchGifs={fetchTrendyGifs}
        gifHeight={70}
        gifWidth={undefined}
        gutter={6}
        hideAttribution
        onGifClick={(gif, e) => {
          e.preventDefault();

          handleGIFClicked(gif);
        }}
        initialGifs={[]}
      />
    </RowContainer>
  );
};

export default GiphyRow;

const RowContainer = styled.div`
  height: 100px;
  & giphy-carousel > a {
    cursor: pointer;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    border: none;
    padding: 0px 10px;
    margin-bottom: 2px;
    box-shadow: none;
  }
`;
